import {
  useInvalidateQueries,
  useUpdateRecord,
} from 'src/api/APIHooks';
import { defaultMutationConfig } from 'src/pages/facesheet/_id/Relationships/Common/api/apiHookOptions';

export const useUpdateNote = (mutationConfig = {}) => {
  const invalidateQueries = useInvalidateQueries();

  return useUpdateRecord('note', {
    api: 'coreApi',
    mutationConfig: {
      onSuccess: () => {
        invalidateQueries('notes');
      },
      ...defaultMutationConfig,
      ...mutationConfig,
    },
  });
};

export default useUpdateNote;
